import moment from 'moment'

export const reservationMixin = {
  computed: {
    status() {
      return this.reservation ? this.reservation.status : ''
    },
    checkinState() {
      return this.reservation ? this.reservation.guest_checkin_state : ''
    },
    checkinCompleted() {
      return this.checkinState == 'completed'
    },
    i18nCheckinState() {
      return this.$t(`reservation.attributes.guest_checkin_states.${this.checkinState.toLowerCase()}`)
    },
    // i18nCustomerContractState() {
    //   if (!this.reservation || !this.reservation.customer_contract_state) return ''
    //   return this.$t(`reservation.attributes.customer_contract_states.${this.reservation.customer_contract_state.toLowerCase()}`)
    // },
    i18nReservationCode() {
      return this.$t('order.show.title', { code: this.order.code })
    },
    bookedNights() {
      return moment(this.reservation.checkout_date).diff(moment(this.reservation.checkin_date), 'days')
    },
    bookedChief() {
      return !!this.reservation && !!this.reservation.guests && this.reservation.guests[0]
    },
    bookedGuestsReached() {
      return !!this.reservation && this.reservation.guests.length === this.reservation.booked_guests
    },
    chiefRoomGuest() {
      return (this.reservation ? this.reservation.guests.find(guest => guest.otpservice_uuid == this.reservation.signer_uuid) : '')
    },
  },
  methods: {
    hasGuestFilledAdvancedData(state) {
      return ['signed', 'signed_document_sent', 'identified', 'identifying'].includes(state)
    },
    hasGuestInGuestsFilledAdvancedData(uuid) {
      if (!this.reservation || !this.reservation.guests) return
      return this.hasGuestFilledAdvancedData(this.reservation.guests.find(guest => guest.otpservice_uuid == uuid)?.otpservice_state)
    },
  },
}
